import $api from '../modules/request';

export const EVENTS = {
  SET_API_KEY: 'api.setAPIKey',
  SET_API_HOST: 'api.setAPIHost',
};

const api = {
  setup(namespace, root) {
    const { handlers } = this;
    Object.keys(handlers).forEach(handlerName => {
      root.on(`${namespace}.${handlerName}`, handlers[handlerName]);
    });
  },
  handlers: {
    setAPIKey: apiKey => {
      $api.mtm.interceptors.request.use(config => {
        config.params = config.params || {}; // eslint-disable-line
        config.params['apikey'] = apiKey; // eslint-disable-line
        return config;
      });
      $api.user.interceptors.request.use(config => {
          config.params = config.params || {}; // eslint-disable-line
          config.params['apikey'] = apiKey; // eslint-disable-line
        return config;
      });
    },
    setAPIHost: host => {
      $api.mtm.defaults.baseURL = host;
      $api.user.defaults.baseURL = host;
    },
  },
};

export default api;
